import { render, staticRenderFns } from "./B2BCreateOrUpdate.vue?vue&type=template&id=415e9f7c&"
import script from "./B2BCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./B2BCreateOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./B2BCreateOrUpdate.vue?vue&type=style&index=0&id=415e9f7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports